import { Component, OnInit, ViewChild } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { ActivatedRoute, Router } from '@angular/router';
import { Http, Response, } from '@angular/http';
import { RequestOptions, Headers } from '@angular/http';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';

import { SelectablesService } from '../selectables.service';
import { ConsignorService } from '../_services/_masters/consignor.service';
import { ProductService } from '../_services/_masters/product.service';
import { RRFormService } from '../r-r-form.service';
import { saveAs } from 'file-saver';
import swal from 'sweetalert2';
import { DatePipe } from '@angular/common';
declare var $ : any;



class Invoice {
	invoice_number: string;
	station: string;
	consignor : string;
	rr_number: string;
	loading: string;
	invoice_by: string;
	invoice_date: string;
	product : string;
	sto_date:string;
}

const authToken = localStorage.getItem('currentUser');
// const http_options = {
// 	headers: new HttpHeaders({
// 		'Content-Type': 'application/json',
// 		'Authorization': `${authToken}`
// 	})
// };
const user_info = JSON.parse(localStorage.getItem('currentUser'));
const headers = new Headers({'Content-Type': 'application/json','Authorization': JSON.parse(localStorage.getItem("user_token"))});
const options = new RequestOptions({ headers: headers });

@Component({
	selector: 'app-invoice',
	templateUrl: './invoice.component.html',
	styleUrls: ['./invoice.component.css']
})
export class InvoiceComponent implements OnInit {
	//bsValue = new Date();
	//bsRangeValue: Date[];
	//bsConfig: Partial<BsDatepickerConfig>;

	invoiceForm : FormGroup;


	table_invoices : Invoice[] = [];

	// stations : string[] = ['LATUR', 'OSMANABAD', 'Station 1', 'Station 2','Station 3', 'Station 4'];
	// consignors : string[] = ['AMBUJA CEMENT LTD.', 'MAHARASHTRA STATE WEARHOUSING CORP.', 'RASHTRIYA CHEMICALS & FERTILIZERS LTD. (K)', 'Consignor 1', 'Consignor 2', 'Consignor 3','Consignor 4', 'Consignor 5', 'Consignor 6', "MEGHNEEL C ADKE"];

	check_branch: boolean = true;
	selected_branch_name="";

	stations : string[] = [];
	products : string[] = [];
	consignors: any[] = [];
	rr_number:any[]=[];

	invoice_date:Date=new Date(Date.now());
	// invoice_date: any = new Date("2018-08-10");
	pipe = new DatePipe('en-US'); // Use your own locale

	selected_load_point:any;
	selected_branch:string;
	selected_client:string;

	selected_godown_to :boolean = false;

	url = environment.url;
	response : any = null;
	query : any = null;

	invoice_data:any = null;
	lr_forms :any = null;
	total_freight : number = null;
	total_weight : number = null;
	on_account_wise_data : any = null;
	sto_wise_data : any = null;
	sto_date_local: any={}
	invoice_form_fields: any={}
	dtOptions: any = {};
	dtTrigger: Subject<any> = new Subject();
	@ViewChild(DataTableDirective)
	dtElement: DataTableDirective;


	constructor( 
		private selectablesService : SelectablesService,
		private selectConsignorService : ConsignorService,
		private selectProductService : ProductService,
		private selectBranchService : SelectablesService,
		public RRFormService:RRFormService,
		private http: Http, 
		private router : Router
		) { }

	ngOnInit() {

		this.selected_godown_to = this.selectablesService.by_godown; 
		this.selected_load_point = this.getSelectedLoadingPoint()
		this.selected_branch = this.selectablesService.selected_branch;
		this.selected_client = this.selectablesService.selected_client;
		// this.invoice_date = this.invoice_date.toISOString();
		console.log (this.invoice_date)
		const now = Date.now();
		const myFormattedDate = this.pipe.transform(now, 'yyyy-MM-dd');
		console.log(myFormattedDate);
		this.invoiceForm = new FormGroup({
			'invoice_number' : new FormControl(null, Validators.required),
			'rr_number' : new FormControl(null, Validators.required),
			'station' : new FormControl(this.selected_branch, Validators.required),
			'consignor' : new FormControl(this.selected_client, Validators.required),
			'loading' : new FormControl(null, Validators.required),
			'invoice_by' : new FormControl(null, Validators.required),
			'invoice_date' : new FormControl(this.invoice_date, Validators.required),
			'product' : new FormControl(null, Validators.required),
			'sto_date' : new FormControl(null, Validators.required)
		});

		this.dtOptions = {
			pagingType: 'full_numbers',
			pageLength: 5,
			// responsive: true,
			// select:true,
			// rowCallback: (row: Node, data: any[] | Object, index: number) => {
			// 	const self = this;
			// 	// Unbind first in order to avoid any duplicate handler
			// 	// (see https://github.com/l-lin/angular-datatables/issues/87)
			// 	$('td', row).unbind('click');
			// 	$('td', row).bind('click', () => {
			// 		self.someClickHandler(data);
			// 	});
			// 	return row;
			// },
			dom: 'Bfrtip',
			// Configure the buttons
			buttons: [
				// 'columnsToggle',
				'colvis',
				'copy',
				'print',
				'excel'
			]
		};
		this.http.get(this.url + '/invoice/all',options)
		// this.http.get('http://backendtransport.iogreen.in/lrform/all')
		.map(this.extractData)
		.subscribe(forms => {
			this.table_invoices = forms;
			console.log(this.table_invoices);
			// Calling the DT trigger to manually render the table
			this.dtTrigger.next();
		});

		var myObject = localStorage.getItem('currentUser');
		var temp = JSON.parse(myObject);	
		if(localStorage.getItem('currentUser'))
		{
			if (temp["role"] === 'Admin')
			{
				this.getBranch();
				this.getRRNumber();
				this.getConsignorBySelectedBranch(null);
				this.check_branch = false;
			}
			else if(temp['role'] === 'Manager' || temp['role'] === 'Employee')
			{
  				this.invoiceForm.get('station').setValue(temp['branch']);
  				this.stations.push(temp['branch']);
				this.getConsignorBySelectedBranch(temp['branch']);
				this.getRRFormWithBranch(temp['branch']);
				this.check_branch = true;
			}
		}
	}

	private extractData(res: Response) {
		const body = res.json();
		console.log(body.data || {});
		return body;
	}
	 getBranch()
    {
     	this.selectBranchService.getBranches()
		.subscribe(
			branches => {
				for(var i=0;i<branches.length;i++)
				{
					this.stations.push(branches[i]['branch_name']);
				}
			});
    }
    getRRNumber()
    {
    	this.RRFormService.getAllRRForm()
		.subscribe(
			rr_number => {
				for(var i=0;i<rr_number.length;i++)
				{
					this.rr_number.push(rr_number[i]['rr_number']);
				}
			});
    }
    getRRFormWithBranch(branch)
    {
    	this.RRFormService.getRRFormWithBranch(branch)
		.subscribe(
			rr_number => {
				for(var i=0;i<rr_number.length;i++)
				{
					this.rr_number.push(rr_number[i]['rr_number']);
				}
			});
    }
    getConsignorBySelectedBranch(branch)
    {
    	this.selected_branch_name=branch;
    	this.consignors=[];
     	this.selectConsignorService.getConsignorFormWithBranch(branch)
		.subscribe(
			consignors => {
				//alert(consignors);
				
				for(var i=0;i<consignors.length;i++)
				{
					this.consignors.push(consignors[i]['consignor_name']);
				}
			});
    }
    getProductBySelectedClient(client)
    {
    	this.products=[];
    	this.selectProductService.getProductByClientName(client)
		.subscribe(
			products => {
				for(var i=0;i<products.length;i++)
				{
					this.products.push(products[i]['product_name']);
				}
			});
    }

	getSelectedLoadingPoint(){
		var point = this.selectablesService.selected_loading_point;
		console.log("getSeletecLoading-GP: " + point);
		if (point == 'rail' || point == 'By Rail'){
			return "By Rail";
		}
		else if(point == 'godown' || point == 'By Godown') {
			return "By Godown";
		}

		else{
			return "By Rail"
		}
	};

	getDataForInvoice(){
		this.invoice_form_fields = {};
		let key; 
		for (key in this.invoiceForm.value) {
			this.invoice_form_fields[key] = this.invoiceForm.get(key).value;
		}
		console.log(this.invoice_form_fields);

		if (this.invoiceForm.get('loading').value == "By Godown" ){
			this.sto_date_local = this.invoice_form_fields["sto_date"]
			var sto_start_date = new Date(this.sto_date_local[0])
			var sto_end_date = new Date(this.sto_date_local[1])
			
			var formatted_sto_start_date = this.pipe.transform(sto_start_date, 'yyyy-MM-dd');
			var formatted_sto_end_date = this.pipe.transform(sto_end_date, 'yyyy-MM-dd');
			
			this.invoice_form_fields["sto_start_date"] = formatted_sto_start_date
			this.invoice_form_fields["sto_end_date"] = formatted_sto_end_date
			
			console.log(JSON.stringify(this.invoiceForm.value));
			this.products = [];
			this.http.post(this.url + '/invoice/process', JSON.stringify(this.invoice_form_fields), options)
			.subscribe(res => {
				this.response =(res.json());
				console.log(this.response)
				if (this.response == null || this.response.length == 0) {
					console.log("response is empty")
					swal('Oops!', 'No Records Found', 'warning')
				}
				else {
					for(var i = 0; i < this.response.length; i ++) {

					if(this.products.includes(this.response[i].product)){

					}
					else{
						this.products.push(this.response[i].product);
					}

				}
				// this.invoiceForm.patchValue({
				// 	"consignor" : this.response[0].consignor,
				// 	"station" : this.response[0].station,
				// 	"loading" : this.response[0].loading
				// });
				}
				
			});

		}
		
		else {
			this.products = [];
			this.query = {
				"loading" : "By Rail",
				"rr_number" : this.invoiceForm.get('rr_number').value
			}
			this.http.post(this.url + '/invoice/process', this.query, options)
			.subscribe(res => {
				this.response =(res.json());
				console.log(this.response)
				if (this.response.length == 0) {

					console.log("response is empty")
					swal('Sorry !', 'No Records Found', 'warning')
				}
				else{

					for(var i = 0; i < this.response.length; i ++) {

						if(this.products.includes(this.response[i].product)){

						}
						else{
							this.products.push(this.response[i].product);
						}

					}
					this.invoiceForm.patchValue({
						"consignor" : this.response[0].consignor,
						"station" : this.response[0].station,
						"loading" : this.response[0].loading
					});
				
				}
			
			});
		}
	};


	generateInvoice(){
		this.invoice_form_fields = {};
		let key; 
		for (key in this.invoiceForm.value) {
			this.invoice_form_fields[key] = this.invoiceForm.get(key).value;
		}
		console.log(this.invoice_form_fields);
		var new_invoice_date = new Date(this.invoiceForm.get("invoice_date").value)
		var formatted_invoice_date = this.pipe.transform(new_invoice_date, 'yyyy-MM-dd');
		this.invoice_form_fields["new_invoice_date"] = formatted_invoice_date
		if (this.invoiceForm.get('invoice_by').value ==="All Info."){
			console.log( this.invoiceForm.value);
			this.http.post(this.url + '/freight/for', this.invoice_form_fields, options)
			// this.http.post(this.url + '/print/byallinfo', this.invoiceForm.value )
			.subscribe(res =>{
				console.log(res.json());
				this.invoice_data = res.json();
				if (this.invoice_data.status == false){
					console.log(this.invoice_data.status);
					swal('Rates or Kms are not Uploaded!', '<b>Station : </b>' + this.invoice_data.rate_query.branch + '<br>' + '<b>Client :</b>'  + this.invoice_data.rate_query.client + '<br>' + '<b>Destiantion :</b>'  + this.invoice_data.rate_query.destination_name + '<br>' + '<b>Kms :</b>'  + this.invoice_data.rate_query.kms , 'warning')
				}
				this.lr_forms = this.invoice_data.lr_forms
				this.total_freight = this.invoice_data.total_freight
				this.total_weight = this.invoice_data.total_weight
			}, error => {
				swal('Oops!', 'Something went wrong on the page!', 'error');
			});
		}


		else if (this.invoiceForm.get('invoice_by').value ==="By On_Account"){
			console.log( this.invoiceForm.value);
			this.http.post(this.url + '/freight/by_onaccount', this.invoice_form_fields , options)
			.subscribe(res =>{
				console.log(res.json());
				this.invoice_data = res.json();
				this.on_account_wise_data = this.invoice_data.on_account_wise_data
				this.total_freight = this.invoice_data.total_freight
				this.total_weight = this.invoice_data.total_weight
				console.log(this.on_account_wise_data)
			}, error => {
				swal('Oops!', 'Something went wrong on the page!', 'error');
			});
		}

		else if (this.invoiceForm.get('invoice_by').value ==="By S.T.O"){
			this.invoice_form_fields = {};
			let key; 
			for (key in this.invoiceForm.value) {
				this.invoice_form_fields[key] = this.invoiceForm.get(key).value;
			}
			this.sto_date_local = this.invoice_form_fields["sto_date"]
			var sto_start_date = new Date(this.sto_date_local[0])
			var sto_end_date = new Date(this.sto_date_local[1])
			var formatted_sto_start_date = this.pipe.transform(sto_start_date, 'yyyy-MM-dd');
			var formatted_sto_end_date = this.pipe.transform(sto_end_date, 'yyyy-MM-dd');
			this.invoice_form_fields["sto_start_date"] = formatted_sto_start_date
			this.invoice_form_fields["sto_end_date"] = formatted_sto_end_date
			console.log(this.invoice_form_fields);
			console.log( this.invoiceForm.get("sto_date").value);
			this.http.post(this.url + '/freight/by_sto', this.invoice_form_fields, options )
			.subscribe(res =>{
				console.log(res.json());
				this.invoice_data = res.json();
				this.sto_wise_data = this.invoice_data.sto_wise_data
				this.total_freight = this.invoice_data.total_freight
				this.total_weight = this.invoice_data.total_weight
				console.log(this.sto_wise_data)
			}, error => {
				swal('Oops!', 'Something went wrong on the page!', 'error');
			});
		}
	};

	saveInvoice(){
		this.invoice_form_fields = {};
		let key; 
		for (key in this.invoiceForm.value) {
			this.invoice_form_fields[key] = this.invoiceForm.get(key).value;
		}
		console.log(this.invoice_form_fields);
		var new_invoice_date = new Date(this.invoiceForm.get("invoice_date").value)
		var formatted_invoice_date = this.pipe.transform(new_invoice_date, 'yyyy-MM-dd');
		this.invoice_form_fields["new_invoice_date"] = formatted_invoice_date
		if (this.invoiceForm.get('invoice_by').value ==="All Info."){
			this.query={
				"invoice_info" : this.invoice_form_fields,
				"invoice_data" : this.lr_forms,
				"total_freight" : this.total_freight,
				"total_weight" : this.total_weight
			}
		}

		else if (this.invoiceForm.get('invoice_by').value ==="By On_Account"){
			this.query={
				"invoice_info" : this.invoice_form_fields,
				"invoice_data" : this.on_account_wise_data,
				"total_freight" : this.total_freight,
				"total_weight" : this.total_weight
			}
		}
		else if (this.invoiceForm.get('invoice_by').value ==="By S.T.O"){
			this.sto_date_local = this.invoice_form_fields["sto_date"]
			var sto_start_date = new Date(this.sto_date_local[0])
			var sto_end_date = new Date(this.sto_date_local[1])
			
			var formatted_sto_start_date = this.pipe.transform(sto_start_date, 'yyyy-MM-dd');
			var formatted_sto_end_date = this.pipe.transform(sto_end_date, 'yyyy-MM-dd');
			
			this.invoice_form_fields["sto_start_date"] = formatted_sto_start_date
			this.invoice_form_fields["sto_end_date"] = formatted_sto_end_date
			console.log(this.invoice_form_fields);
			this.query={
				"invoice_info" : this.invoice_form_fields,
				"invoice_data" : this.sto_wise_data,
				"total_freight" : this.total_freight,
				"total_weight" : this.total_weight
			}
		}

		console.log(this.query)
		this.http.post(this.url + '/invoice/save', this.query, options)
		.subscribe(res =>{
			console.log(res);
			var response = res.json();
			if(response['status'])
			{
				swal('Save', 'Record save successfully', 'success');
				this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
					dtInstance.destroy();
					this.http.get(this.url + '/invoice/all', options)
						.map(this.extractData)
						.subscribe(forms => {
						this.table_invoices = forms;
						console.log(this.table_invoices);
						// Calling the DT trigger to manually render the table
						this.dtTrigger.next();
						window.open(this.url + "/invoice/print/" + ( this.table_invoices[0].invoice_number ) + "/" +(this.table_invoices[0].invoice_by), "_blank");
					});
				});
				console.log (this.table_invoices[0].invoice_number )
				// window.open(this.url + "/lrform/test/print/" + ( this.lrform[0].lr_number ), "_blank");

			}
			else
			{
				swal('Oops!', 'Invoice is already generated for <strong>' + this.invoiceForm.get('invoice_by').value + ' </strong>type', 'warning');
			}
		});

	}

	someClickHandler(info: any): void {
		this.http.get(this.url + '/invoice/info/' + info[0], options)
		.subscribe(res=>{
			console.log(res.json());
		})
		// this.lRFormService.getLRFormWith(info[1])
		// .subscribe(response => {
		// 	console.log('aaaaa'+JSON.stringify(response))
		// 	this.modalData = JSON.stringify(response)
		// 	this.modalData =JSON.parse(this.modalData)
		// 	// console.log(this.modalData[0].basic_info.product);
		// 	this.modalLRForm.patchValue({
		// 		"consignor": this.modalData[0].consignor,
		// 		"loading": this.modalData[0].loading,
		// 		"station": this.modalData[0].station,
		// 		'product': this.modalData[0].product,
		// 		"sto_number": this.modalData[0].sto_number,
		// 		"lr_number": this.modalData[0].lr_number,
		// 		"lr_date": this.modalData[0].lr_date,
		// 		'on_account': this.modalData[0].on_account,
		// 		'party' : this.modalData[0].party,
		// 		'destination' : this.modalData[0].destination,
		// 		'truck_number': this.modalData[0].truck_number,
		// 		'owned_by': this.modalData[0].owned_by,
		// 		'freight_rate' : this.modalData[0].freight_rate,
		// 		'freight_amt' : this.modalData[0].freight_amt,
		// 		'advance_paid' : this.modalData[0].advance_paid,
		// 		'balance' : this.modalData[0].balance,
		// 		'diesel_amt' : this.modalData[0].diesel_amt,
		// 		'rr_date' : this.modalData[0].rr_date,
		// 		'rr_number' : this.modalData[0].rr_number,
		// 		'weight': this.modalData[0].weight,
		// 		'qty_bags':this.modalData[0].qty_bags

		// 	});
		// });	
		$("#modal-fs").modal('show');
	};

	printInvoice(id:any, invoice_by:any){
		window.open(this.url + "/invoice/print/" +  id + "/" + invoice_by, "_blank");
	}

	deleteInvoice(invoice_number){
		console.log(invoice_number);
		swal({
			title: 'Are you sure?',
			text: "You won't be able to revert this!",
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Yes, delete it!'
		}).then((result) => {
			if (result.value) {
				this.http.post( this.url + "/invoice/delete", {"invoice_number" :invoice_number}, options)
				.subscribe(res => {
					console.log(res.json());
					var feedback = res.json();
					if (feedback.status){
						$("#default-modal").modal('hide');
						swal(
							'Deleted!',
							'Your Invoice Receipt has been deleted.',
							'success'
						);
						this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
							dtInstance.destroy();
							this.http.get(this.url + '/invoice/all',options)
								.map(this.extractData)
								.subscribe(forms => {
								this.table_invoices = forms;
								console.log(this.table_invoices);
								// Calling the DT trigger to manually render the table
								this.dtTrigger.next();
							});
						})
					}
				});
			}
		})
	};

	downloadInvoice(invoice_number, invoice_by){
		this.http.post( this.url + "/invoice/download", {"invoice_number" :invoice_number, "invoice_by" : invoice_by}, options)
		.subscribe(res => {
			console.log(res);
			console.log(res.text());
			let blob = new Blob([res.text()], { type: 'text/csv' });
			saveAs(blob, "invoice.csv");
		});
	};
}




// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/invoice/invoice.component.ts